import { Component, OnInit } from '@angular/core';

declare function ineum(s: string, ...parameters: any[]): any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}